import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../ui/Icon";

const TrendsZoomIn = () => {
  const navigate = useNavigate();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <main className="relative my-10 mx-5">
      {/* Back Button */}
      <div className="fixed left-4 top-4 z-50">
        <button onClick={() => navigate(-1)}>
          <Icon src="/assets/svgs/back_btn.svg" alt="Back" />
        </button>
      </div>

      {/* Zoom In Image */}
      <section className="p-2 flex items-center justify-center">
        <div className="">
          <img
            src="/assets/svgs/trends-svgs/zoomIn_trends.svg"
            alt="Trends zoom in"
            className="w-full h-auto object-contain"
          />
        </div>
      </section>
    </main>
  );
};

export default TrendsZoomIn;
